<script lang="ts" setup>
export interface Props {
  prices: {
    finalPrice?: string | number
    regularPrice: string | number
  }
}

const props = defineProps<Props>()

const showDiscount = computed(() => {
  return props.prices.regularPrice && parseFloat(props.prices.regularPrice) > parseFloat(props.prices.finalPrice)
})

const regularPrice = computed(() => {
  return Number(props.prices?.regularPrice || 0)
})

const finalPrice = computed(() => {
  return Number(props.prices?.finalPrice || 0)
})
</script>

<template>
  <div
    class="price"
    :class="{
      'has-sale': showDiscount, // deprecated
      'price--sale': showDiscount,
    }"
  >
    <slot name="prefix" />

    <i18n-n
      v-if="regularPrice"
      tag="span"
      :value="regularPrice"
      :format="{ style: 'currency', currency: 'EUR', ...(Number.isInteger(prices.regularPrice) ? { maximumFractionDigits: 0 } : {}) }"
      class="price__regular-price"
      :class="{ 'price--rounded': regularPrice === Math.round(regularPrice) }"
    >
      <template #currency="slotProps">
        <span class="price__currency">{{ slotProps.currency }}</span>
      </template>
      <template #integer="slotProps">
        <span class="price__integer">{{ slotProps.integer }}</span>
      </template>
      <template #decimal="slotProps">
        <span class="price__decimal">{{ slotProps.decimal }}</span>
      </template>
      <template #fraction="slotProps">
        <span class="price__fraction">{{ slotProps.fraction }}</span>
      </template>
    </i18n-n>

    <i18n-n
      v-if="showDiscount && finalPrice"
      tag="span"
      :value="finalPrice"
      :format="{ style: 'currency', currency: 'EUR', ...(Number.isInteger(prices.finalPrice) ? { maximumFractionDigits: 0 } : {}) }"
      class="price__final-price"
      :class="{ 'price--rounded': finalPrice === Math.round(finalPrice) }"
    >
      <template #currency="slotProps">
        <span class="price__currency">{{ slotProps.currency }}</span>
      </template>
      <template #integer="slotProps">
        <span class="price__integer">{{ slotProps.integer }}</span>
      </template>
      <template #decimal="slotProps">
        <span class="price__decimal">{{ slotProps.decimal }}</span>
      </template>
      <template #fraction="slotProps">
        <span class="price__fraction">{{ slotProps.fraction }}</span>
      </template>
    </i18n-n>
  </div>
</template>

<style>
@import url("~layers/app/components/Ui/Price.css");
</style>
